<div class="detailed-user"
     *ngIf="user | async as user"
     [ngClass]="iconPosition">
    <div class="identicon">
        <img src="{{ user?.identiconDataUrl }}"
             [alt]="userName"
             loading="lazy" />
        <div class="user-role"
             *ngIf="titleKeyTrad">
            <div class="highlighting pata-role"
                 [ngClass]="titleKeyTrad | lowercase">
                {{ titleKeyTrad | translate}}
            </div>
        </div>
    </div>
    <div class="title">
        <div>
            <i class="fal fa-id-badge"
               aria-hidden="true">
            </i>
        </div>
        <div>{{ user.displayName }}</div>
    </div>
    <div class="email">
        <div>
            <i class="fal fa-envelope-open-text"
               aria-hidden="true">
            </i>
        </div>
        <div>
            <a class="medium-text-link"
               [href]="user.email | mailto">
                {{ user.email }}
            </a>
        </div>
    </div>
    <div class="phone">
        <div>
            <i class="fal fa-phone"
               aria-hidden="true">
            </i>
        </div>
        <div>
            <a class="medium-text-link"
               [href]="user.displayPhoneNumber | telto">
                {{ user.displayPhoneNumber }}
            </a>
        </div>
    </div>
</div>
